import { inject } from '@angular/core';
import { CanActivateChildFn, CanActivateFn, Router } from '@angular/router';
import { Logger } from '@gci/helpers/logger';
import { AuthService } from 'app/core/auth/auth.service';
import { environment } from 'environments/environment';
import { of, switchMap } from 'rxjs';

export const AuthGuard: CanActivateFn | CanActivateChildFn = (route, state) => {
    const router: Router = inject(Router);
    const authService = inject(AuthService);
    const logger = new Logger('AuthGuard');

    const language = route.queryParamMap.get("lang");
    let langParam = '';
    if (language) {
        langParam = `&lang=${language}`;
    }

    // Check the authentication status
    return authService
        .check()
        .pipe(
            switchMap((authenticated) => {

                // If the user is not authenticated...
                if (!authenticated) {
                    // Redirect to the sign-in page with a redirectUrl param
                    const redirectURL =
                        state.url === '/sign-out'
                            ? ''
                            : `redirectURL=${state.url}`;

                    const urlTree = router.parseUrl(`sign-in?${redirectURL}${langParam}`);
                    logger.log("state.url", state.url, "urlTree", urlTree);

                    return of(urlTree);
                }

                // Check if the user is a superadmin
                if (authService?.currentUser?.tenant_code_access === environment.idSuperAdmin) {
                    router.navigate(['superadmin/home'])
                    return of(false);
                }

                // Allow the access
                return of(true);
            })
        );

};
